var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "profile-field__title" }, [_vm._v("Автомобиль")]),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c(
          "div",
          [
            _c("c-switcher", {
              attrs: { label: "Есть автомобиль" },
              model: {
                value: _vm.hasAuto,
                callback: function ($$v) {
                  _vm.hasAuto = $$v
                },
                expression: "hasAuto",
              },
            }),
          ],
          1
        ),
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.hasAuto
            ? _c("div", { staticClass: "params" }, [
                _c(
                  "div",
                  { staticClass: "param brand" },
                  [
                    _c("c-input", {
                      attrs: {
                        "floating-label": "Марка",
                        clearable: true,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.brand,
                        callback: function ($$v) {
                          _vm.brand = $$v
                        },
                        expression: "brand",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "param model" },
                  [
                    _c("c-input", {
                      attrs: {
                        "floating-label": "Модель",
                        clearable: true,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.model,
                        callback: function ($$v) {
                          _vm.model = $$v
                        },
                        expression: "model",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "param year" },
                  [
                    _c("c-input", {
                      attrs: {
                        type: "price-number",
                        "fractional-length": 0,
                        "floating-label": "Год выпуска",
                        clearable: true,
                        "max-length": 4,
                        required: _vm.error && _vm.error.year,
                        "required-message": _vm.error && _vm.error.year,
                        "required-condition": _vm.error && _vm.error.year,
                      },
                      model: {
                        value: _vm.year,
                        callback: function ($$v) {
                          _vm.year = $$v
                        },
                        expression: "year",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "param category" },
                  [
                    _c("c-input", {
                      attrs: {
                        "floating-label": "Категория прав",
                        clearable: true,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.category,
                        callback: function ($$v) {
                          _vm.category = $$v
                        },
                        expression: "category",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }